export const BOOKING_BACKGROUND_CSS_MAX_LENGTH = 2000;

/** An https or same-site image URL that can sit inside url("…") without ending it. */
export function isSafeImageUrl(url: string): boolean {
  return url.length <= 1000 && /^(https:\/\/|\/)[^\s"'()\\<>]+$/.test(url);
}

/** A CSS background-position given as two percentages, such as "35% 45%". */
export function isSafeBackgroundPosition(position: string): boolean {
  return /^\d{1,3}% \d{1,3}%$/.test(position);
}

/** The value is rendered as one CSS background property, so nothing may end it, open another rule or leave the style attribute. */
export function isSafeBackgroundCss(css: string): boolean {
  return (
    css.length <= BOOKING_BACKGROUND_CSS_MAX_LENGTH &&
    !/[;{}<>\\]|expression\s*\(|javascript:|@import/i.test(css)
  );
}
